module.exports = __webpack_public_path__ + "img/newsImg11-6.00de3c06.png";